module.exports = __webpack_public_path__ + "img/bg-4.a7fcd7c5.jpg";